import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { Container, Grid, Typography } from '@material-ui/core';

import { RootState } from 'redux/reducers/type';
import { ViewMode } from 'commons/constants/KeyFlowConstants';
import { ViewModeType } from 'commons/constants/type';
import useWkblVideo from 'hooks/useWkblVideo';
import { SquareSwitch } from 'components/Switch';
import { Pagination } from 'components/Pagination';
import { AssetListView } from 'components/AssetListView';
import { AssetThumbnailView } from 'components/AssetThumbnailView';
import { useStyles } from 'components/SearchResult';
import { OrderSelect, PageReturnSelect } from 'components/Select';
import { addComma } from '../../commons/utils/commonUtil';

function SearchResultByDate() {
  const classes = useStyles();

  const { videoList, isLoading, pagination, searchCondition } = useSelector(
    (state: RootState) => state.wkblVideo,
  );

  const {
    onClearWkblVideoList,
    onChangeWkblVideoPage,
    onChangeWkblVideoAsc,
    onChangeWkblVideoReturnCount,
    onChangeWkblVideoSort,
  } = useWkblVideo();

  const [viewMode, setViewMode] = useState<ViewModeType>(ViewMode.THUMBNAIL);

  const isEmptyData = useMemo(() => {
    return videoList.length === 0;
  }, [videoList.length]);

  useEffect(() => {
    return () => {
      onClearWkblVideoList();
    };
  }, [onClearWkblVideoList]);

  const onChangePage = useCallback(
    (pageNumber: number) => {
      onChangeWkblVideoPage(pageNumber);
    },
    [onChangeWkblVideoPage],
  );

  const onChangeViewMode = useCallback(() => {
    if (viewMode === ViewMode.LIST) {
      setViewMode(ViewMode.THUMBNAIL);
    } else {
      setViewMode(ViewMode.LIST);
    }
  }, [viewMode]);

  return (
    <Container component="article" className={classes.root}>
      <div className={classes.optionContainer}>
        <p className={classes.resultCount}>검색 결과 : {addComma(pagination.itemCount)}개</p>

        <div className={classes.searchOptionContainer}>
          <SquareSwitch onChange={onChangeViewMode} value={viewMode} />
          <OrderSelect
            asc={searchCondition.asc}
            sort={searchCondition.sort}
            onChangeAsc={onChangeWkblVideoAsc}
            onChangeSort={onChangeWkblVideoSort}
          />
          <PageReturnSelect
            returnCount={pagination.returnCount || searchCondition.retr}
            onChangeReturnCount={onChangeWkblVideoReturnCount}
          />
        </div>
      </div>
      {isEmptyData ? (
        <Grid container justifyContent="center" className={classes.emptyDataContainer}>
          <Grid item xs={4}>
            <Typography>데이터가 존재하지 않습니다.</Typography>
          </Grid>
        </Grid>
      ) : viewMode ? (
        <AssetListView />
      ) : (
        <AssetThumbnailView />
      )}
      <Grid container justifyContent="center">
        <Grid item xs={9} className={classes.paginationContainer}>
          <Pagination pagination={pagination} onChangePage={onChangePage} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default SearchResultByDate;
